import React, { useState, useEffect } from 'react';
import { useTable, usePagination, useSortBy, useFilters } from 'react-table'
import axios from 'axios';

const columns = [
	{
		Header: 'Download',
		accessor: "download_location",
		Cell: ({ value }) => {
			if (value) {
				return (
					<a href={value} className="bg-white -ml-3 hover:text-purple-500 font-semibold py-3 px-4 mb-2 border border-gray-400 rounded shadow">
						Download
					</a>
				)

			} else {
				return ""
			}
		}
	},
	{Header: 'Report Name', accessor: "job_id"},
	{Header: 'Submitted Date', accessor: "submitted_date"},
	{Header: 'Run Date', accessor: "last_run"},
	{Header: 'Interval', accessor: "schedule"},
	{Header: 'Date Range', accessor: "date_range"},
	{Header: 'Next Run Date', accessor: "next_run"},
	{
		Header: 'Report Status',
		accessor: "active",
		Cell: ({ value, getCellProps }) => {
			return value ? "Active": "Inactive"
		}
	},
	{Header: "Run Count", accessor: "run_count"}
]

// let data = [
// 	{date: "2023-02-12", reportName:"Top 5 Monthly Credit Card Spends", dateRange:"2023-01-13 - 2023-02-12", reportStatus: "Ready", download:"Download"},
// 	{date: "2023-02-11", reportName:"Weekly Credit Card Minimum Spend Report", dateRange:"2023-02-04 - 2023-02-11", reportStatus: "Ready", download:"Download"},
// 	{date: "2023-01-31", reportName:"Quarterly Credit Card Max Balance", dateRange:"2022-10-01 - 2023-01-31", reportStatus: "Ready", download:"Download"},
// 	{date: "2023-01-01", reportName:"Annual Top 5 Credit Card Spends", dateRange:"2022-01-01 - 2022-12-31", reportStatus: "Ready", download:"Download"},
// 	{date: "2023-01-01", reportName:"Annual Credit Card Max Balance", dateRange:"2022-01-01 - 2022-12-31", reportStatus: "Ready", download:"Download"},
// ]

export default function QueryResults(args) {
	const [search, setSearch] = useState('');
	const [data, setData] = useState([]);

	useEffect(() => {
		axios.get('/api/list_jobs/').then((response) => {
			setData(response.data)
		})
	}, [])

	const {
  	  getTableProps,
  	  getTableBodyProps,
  	  headerGroups,
  	  prepareRow,
  	  page,
  	  canPreviousPage,
  	  canNextPage,
  	  pageOptions,
  	  pageCount,
  	  gotoPage,
  	  nextPage,
  	  previousPage,
  	  state: { pageIndex },
  	} = useTable(
  	  {
  	    columns,
  	    data,
  	    initialState: { pageIndex: 0 },
  	  },
  	  useFilters,
  	  useSortBy,
  	  usePagination,
  	)

        return (
            <>
                <div className="p-6 w-4/5" style={{marginLeft: "8rem"}}>
                    <h1 className="text-3xl py-4 px-3 ml-5 border-b mb-10">Query Results</h1>
					<div className="p-5 mb-10 ml-5 bg-white shadow">
						<h2 className="bg-purple-l border-b border-gray-200 px-6 py-2 text-white font-bold tracking-wider uppercase text-md">
	  					    Results Search
	  					</h2>
      					<div className="flex flex-col justify-center px-6 mt-5">
      					  <label className="block tracking-wide text-gray-600 text-xs font-bold mb-2" htmlFor="name">Search</label>
      					  <input
	  					    className="appearance-none border rounded w-2/3 py-2 px-3 text-lg text-gray-800 leading-tight focus:outline-none focus:shadow-outline"
      					    type="text"
      					    id="name"
							placeholder={'Search...'}
      					    value={search}
      					    onChange={(event) => setSearch(event.target.value)}
      					  />
						</div>
					</div>
					
					<div className="p-5 mb-10 ml-5 bg-white shadow">

						<div className="w-full overflow-x-scroll">
      					  <table className="border-collapse table-auto w-full whitespace-no-wrap bg-white table-striped relative" {...getTableProps()}>
      					    <thead>
      					      {headerGroups.map(headerGroup => (
      					        <tr className="text-left" {...headerGroup.getHeaderGroupProps()}>
      					          {headerGroup.headers.map(column => (
      					            <th className="bg-purple-l sticky top-0 border-b border-gray-200 px-6 py-2 text-white font-bold tracking-wider uppercase text-xs" {...column.getHeaderProps(column.getSortByToggleProps())}>
      					              {column.render('Header')}
      					              {/* Add a sort direction indicator */}
      					              <span>
      					                {column.isSorted
      					                  ? column.isSortedDesc
      					                    ? <i className="fas fa-chevron-down ml-1"></i>
      					                    : <i className="fas fa-chevron-up ml-1"></i>
      					                  : ''}
      					              </span>
      					            </th>
      					          ))}
      					        </tr>
      					      ))}
      					    </thead>
      					    <tbody {...getTableBodyProps()}>
      					      {page.map((row, i) => {
      					        prepareRow(row)
      					        return (
      					          <tr {...row.getRowProps()}>
      					            {row.cells.map(cell => {
											  return (
												<td className="border-dashed border-t border-gray-200" {...cell.getCellProps()}>
												  <span className="text-gray-800 px-6 py-3 flex items-center">
													{cell.render('Cell')}
												  </span>
												</td>
											)
										})
									}
      					          </tr>
      					        )
      					      })}
      					    </tbody>
      					  </table>
      					</div>
      					<div className="pagination my-2">
      					  <button onClick={() => gotoPage(0)} disabled={!canPreviousPage} className="shadow rounded-lg inline-flex items-center bg-white hover:text-purple-500 focus:outline-none focus:shadow-outline text-gray-500 font-semibold py-2 px-2 md:px-4">
      					    {'<<'}
      					  </button>{' '}
      					  <button onClick={() => previousPage()} disabled={!canPreviousPage} className="shadow rounded-lg inline-flex items-center bg-white hover:text-purple-500 focus:outline-none focus:shadow-outline text-gray-500 font-semibold py-2 px-2 md:px-4">
      					    {'<'}
      					  </button>{' '}
      					  <button onClick={() => nextPage()} disabled={!canNextPage} className="shadow rounded-lg inline-flex items-center bg-white hover:text-purple-500 focus:outline-none focus:shadow-outline text-gray-500 font-semibold py-2 px-2 md:px-4">
      					    {'>'}
      					  </button>{' '}
      					  <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage} className="shadow rounded-lg inline-flex items-center bg-white hover:text-purple-500 focus:outline-none focus:shadow-outline text-gray-500 font-semibold py-2 px-2 md:px-4">
      					    {'>>'}
      					  </button>{' '}
      					  <span className="text-gray-800 px-6 py-1">
      					    Page{' '}
      					    <strong className="text-gray-800 px-6 py-1">
      					      {pageIndex + 1} of {pageOptions.length}
      					    </strong>{' '}
      					  </span>
      					</div>
					</div>
                </div>
            </>
        )

}
